export default Object.freeze({
  TITLE: '운영자 계정등록',
  AGREE: '약관동의',
  INFO: '운영자 정보입력',
  OVER: '계정 등록 완료',
  COLLECT: '개인정보 수집 및 이용',
  REGISTERED: '운영자 계정등록이 완료되었습니다.',
  ADMIN_ID: '운영자 아이디:',
  ADMIN_INFO: '운영자 정보:',
  PHONE_NO: '전화번호:',
  MOBILE_NO: '휴대폰번호:',
  LOGIN: '로그인',
  ALREADY_DELETE: '이미 삭제 처리 된 운영자 계정입니다.',
  ALERT_CHECK: '개인정보 수집 및 이용 에 체크해주세요',
  JOINED: '이미 가입 완료 된 운영자 계정입니다.',
  NEXT: '다음',
  INFO_AGREE: '개인정보 수집 및 이용에 동의합니다.',
  TITLE1: '1. 수집하는 개인정보의 항목',
  TITLE1_INFO:
    '회사가 제공하는 SA 운영자 계정생성 및 SA 서비스 제공을 위해 아래와 같이 이용자의 개인정보를 수집하고 있습니다.',
  TITLE1_SUB1: '1) 사업자 정보를 수집합니다.',
  TITLE1_SUB2: '2) 계정 생성을 요청한 이용자의 개인정보를 수집합니다.',
  TITLE1_SUB3: '3) 서비스 이용과정에서 다음과 같은 정보가 생성되어 수집 될 수 있습니다.',
  TITLE2: '2. 개인정보 수집목적 및 이용목적',
  TITLE3: '3. 개인정보 보유 및 이용기간',
  TITLE1_SUB1_DETAIL1:
    '- (필수) 회사명, 사업자 등록번호, 대표자명, 업종, 업태, 대표전화번호, 대표 e메일, 사업장 주소, 쇼핑몰명, 쇼핑몰계좌정보(계좌번호, 예금주명)',
  TITLE1_SUB1_DETAIL4: '- (선택) 팩스번호, 통신판매신고번호, 개인정보 관리책임자 정보(담당자명, 전화번호)',
  TITLE1_SUB2_DETAIL1: '- (필수) ID, 비밀번호, 성명, 직급, 전화번호, 휴대폰번호, 이메일',
  TITLE1_SUB2_DETAIL2: '- (선택) 소속부서, 직책',
  TITLE1_SUB3_DETAIL1: '- 운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역',
  TITLE2_INFO: '회사는 수집 한 개인정보를 다음과 같은 목적을 위해 활용합니다.',
  TITLE2_SUB1: '1) 서비스 제공에 대한 계약 이행 및 서비스 제공에 따른 요금정산',
  TITLE2_SUB1_DETAIL1: '- 서비스 및 콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심',
  TITLE2_SUB2: '2) 운영자 계정관리',
  TITLE2_SUB2_DETAIL1:
    '- 서비스 제공, 개인식별, 부정 이용방지와 비인가 사용방지, 계정등록 의사 확인, 계정중복등록 제한, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리,',
  TITLE2_SUB2_DETAIL2: '고지사항 전달',
  TITLE2_SUB3: '3) 신규서비스 개발 및 마케팅',
  TITLE2_SUB3_DETAIL1:
    '- 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및',
  TITLE2_SUB3_DETAIL2: '참여기회 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계',
  TITLE3_INFO1: '이용자의 개인정보는 원칙적으로 운영자 삭제 시까지 보존하며 운영자 삭제 시 지체 없이 파기합니다.',
  TITLE3_INFO2:
    '단, 관계법령의 규정에 의하여 보전할 필요가 있는 경우 명시한 기간 동안 보존하며, 그 외 다른 목적으로는 절대 사용하지 않습니다.',
  TITLE3_INFO3:
    '운영자 삭제 시 해당 운영자의 개인정보를 지체 없이 파기하며, 복구 및 재생되지 않도록 기술적 방법을 이용하여 완전하게 삭제합니다.',
  TITLE3_SUB1: '1) 권한내역 (권한부여, 변경, 삭제 등의 기록)',
  TITLE3_SUB1_DETAIL1: '- 보존이유 : 개인정보보호법',
  PERIOD5: '- 보관기간 : 5년',
  PERIOD1: '- 보관기간 : 1년',
  PERIOD3: '- 보관기간 : 3년',
  TITLE3_SUB2: '2) 접속기록 (운영자 아이디, 접속 IP주소, 접속 일시, 서비스 이용내역)',
  SAVE_REASON: '- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률',
  TITLE3_SUB3: '3) 소비자의 불만 또는 분쟁처리에 관한 기록',
  TITLE3_SUB4: '4) 계약 또는 청약철회 등에 관한 기록',
  TITLE3_SUB5: '5) 대금결제 및 재화 등의 공급에 관한 기록',
  MUST_ORDER: '주문번호는 필수 입니다.',
  INFO_INPUT: '운영자 정보입력',
  ID: '아이디',
  CHECK_DUO: '중복확인',
  FIVE_TWENTY: '5~20자리 영문 소문자, 숫자를 사용하실 수 있습니다.',
  MORE_THAN_FIVE: ' 5자 이상의 아이디를 입력해주세요.',
  USEFUL_ID: ' 사용 가능한 아이디입니다.',
  USED_ID: ' 이미 사용 중인 아이디입니다.',
  WRONG: '입력형식이 잘못되었습니다.',
  PASS: '비밀번호',
  PASS_TIP: '영문,숫자,특수문자를 조합하여 8~20자리로 설정하셔야 합니다.',
  FAIL_SHORT: ' 8자리 이상의 비밀번호를 입력해주세요.',
  AT_LEAST_2: ' 영문,숫자,특수문자 중 2종류 이상 조합하여 입력해주세요.',
  AT_LEAST_3: ' 영문,숫자,특수문자를 3종류 모두 조합하여 입력해주세요.',
  NOT_SPECIAL: ' !@#$%^&+=-_.() 특수문자만 사용 가능합니다.',
  PASS_CONFIRM: '비밀번호 확인',
  SAME_PASS: ' 비밀번호가 동일합니다.',
  PASS_RECONFIRM: ' 비밀번호를 다시 확인해주세요.',
  ADMIN_NAME: '운영자명',
  JOB_POSITION: '직급',
  DEPART_NAME_DUTY: '소속부서 / 직책',
  PHONE_NO_TTL: '전화번호',
  MOBILE_NO_TTL: '휴대폰번호',
  ONLY_NUMETC: '숫자와 - 만 입력 가능',
  CERTIFICATE: '인증번호발송',
  PHONE_SURE_AGAIN: '휴대폰번호를 다시 확인 해 주세요.',
  CERTIFICATE_SUCCESS: '인증 완료되었습니다.',
  CERTIFICATE_FAILED: '인증 실패했습니다.',
  REGISTER_OVER: '이미 등록 완료된 계정입니다.',
  ERROR_HAPPEN: '오류가 발생하였습니다.',
  CHECK_ID_DUO: '아이디 중복 확인이 필요합니다.',
  CHECK_PASS: '비밀번호를 확인해주세요.',
  NEED_JOB_POSITION: '직급을 입력해주세요.',
  NEED_PHONE: '전화번호를 입력해주세요.',
  NEED_MOBILE: '휴대폰 번호를 입력해주세요.',
  CONFIRM_SEND: '입력하신 내용으로 운영자 계정을 신청합니다.',
  EXPIRED: '신청 이용 기간 만료',
  DATE_EXPIRED: '이용 가능한 기간이 만료되었습니다.',
  SURE: '확인 후 재 신청 진행해 주시기 바랍니다.',
  THANK: '감사합니다.',
  MAIN: '메인으로',
  SEND_CODE: '휴대폰 번호로 인증코드가 전송되었습니다.',
  INPUT_CODE: '인증코드 입력',
  SMS_CERTIFICATE_OVER: '인증완료',
  MOBILE_TYPE_CHECK: '휴대폰번호 형식을 확인해주세요.',
  SMS_CERTIFICATE_CHECK: 'SMS 인증을 진행해 주시기 바랍니다.',
  SELECT_DEPARTMENT: '부서선택',
  SELECT_JOBDUTY: '직책선택',
  SERVER_ERROR: '서버 오류 발생',
});
